import React from "react"
import "./chart.scss"
import {
	AreaChart,
	Area,
	XAxis,
	CartesianGrid,
	Tooltip,
	ResponsiveContainer,
} from "recharts"

export const Chart = ({aspect, title}) => {
	const data = [
		{
			name: "January",
			amt: 1200,
		},
		{
			name: "February",
			amt: 2210,
		},
		{
			name: "March",
			amt: 800,
		},
		{
			name: "April",
			amt: 2000,
		},
		{
			name: "May",
			amt: 900,
		},
		{
			name: "June",
			amt: 1700,
		},
	]

	return (
    <div className="chart">
			<div className="title">{ title}</div>
			<ResponsiveContainer width="100%" 	aspect={aspect}>
				<AreaChart
					width={730}
					height={250}
					data={data}
					margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
				>
					<defs>
						<linearGradient id="amt" x1="0" y1="0" x2="0" y2="1">
							<stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
							<stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
						</linearGradient>
					</defs>
					<XAxis dataKey="name" stroke="gray" />
					<CartesianGrid strokeDasharray="3 3" className="chartGrid" />
					<Tooltip />
					<Area
						type="monotone"
						dataKey="amt"
						stroke="#82ca9d"
						fillOpacity={1}
						fill="url(#amt)"
					/>
				</AreaChart>
			</ResponsiveContainer>
		</div>
	)
}
